import type { InteractiveLessonSectionFragment } from '../../lesson-builder.graphql.generated';
import { InquisitiveActivitiesComponentType } from 'global/graphql/scalars.type';
import { ComponentActivity } from '../component.constants';
import type { Pluck } from 'lib/gql/pluck';

export type SettingsProps = Omit<ComponentActivity, '__typename'> & {
  contentId: number;
};

export type QuestionSettingCurrentSubActivity = {
  id: string;
  type: InquisitiveActivitiesComponentType;
  __typename: string;
};

export type ActivityProperties = Pluck<
  Extract<
    Pluck<InteractiveLessonSectionFragment, 'components'>,
    { __typename: 'ActivitiesActivityComponent' }
  >,
  'properties'
>;

export const ACTIVITY_ID_PREFIX = 'activity-';
